import React from "react"

const TryItNow = ()=>{
    return (<div>Try It now Page</div>)
}

export default TryItNow;